import { Wrapper } from "./styles";
import ScrollAnimationWrapper from "../helpers/ScrollAnimationWrapper";

interface ComodidadeProps {
  comodidadeImg: any;
  textSup: string;
  textSub: string;
}

export function Comodidade({
  comodidadeImg,
  textSup,
  textSub,
}: ComodidadeProps) {
  return (
    <Wrapper>
      <ScrollAnimationWrapper animateIn="animate__zoomIn">
        <img src={comodidadeImg} alt="Comodidade" />
      </ScrollAnimationWrapper>
      <div>
        <h3>{textSup}</h3>
        <p>{textSub}</p>
      </div>
    </Wrapper>
  );
}
